import translate from 'angular-translate';

export default angular.module('eventix.common.services.laravelValidationRules',[translate])
/**
 * @ngdoc service
 * @name eventix.common.services.LaravelValidationRules
 * @description
 * A service for managing the validation of metadata extra rules It mimicks the validation rules available in Laravel [1].
 *
 * Basic structure is an object with rule names as keys. Each key contains an object with the following functions.
 *
 * <pre>
 * alpha: {
 *    label: 'Alpha',
 *    new: function(){} // Generates a rule config for this validation rule
 *    validateRule: function(rule, rules){} // Check if rule config is valid, accepts the rule to validate and its siblings
 *    invalidValue: function(value, args, values, metaData){} // Check if field is valid according to metadata rule
 *    template: '<input />' // HTML template for configuring the rule
 * }
 * </pre>
 *
 * [1] https://laravel.com/docs/5.2/localization
 */
    .factory('LaravelValidationRules', function($translate, $sce, MetaData, $log) {
        var Rules = {
            alpha: {
                label: $translate.instant('validation.rules.alpha'),
                new: function() {
                    return {
                        name: 'alpha',
                        args: []
                    };
                },
                validateRule: angular.noop,
                invalidValue: (value) => !/^[a-zA-Z]*$/.test(value),
                template: () => $translate.instant('validation.template.alpha')
            },
            alpha_num: {
                label: $translate.instant('validation.rules.alpha_num'),
                new: function() {
                    return {
                        name: 'alpha_num',
                        args: []
                    };
                },
                validateRule: angular.noop,
                invalidValue: (value) => !/^[a-zA-Z0-9]*$/.test(value),
                template: () => $translate.instant('validation.template.alpha_num')
            },
            alpha_dash: {
                label: $translate.instant('validation.rules.alpha_dash'),
                new: function() {
                    return {
                        name: 'alpha_dash',
                        args: []
                    };
                },
                validateRule: angular.noop,
                invalidValue: (value) => !/^[a-zA-Z0-9-]*$/.test(value),
                template: () => $translate.instant('validation.template.alpha_dash')
            },
            after: {
                label: $translate.instant('validation.rules.after'),
                new: function() {
                    return {
                        name: 'after',
                        args: ['']
                    };
                },
                validateRule: function(rule) {
                    rule.args[0] = rule.args[0].replace(/[^\d-]*/g,'');
                },
                invalidValue: (value, args) => args[0] < value,
                template: () => {
                    var template = $translate.instant('validation.template.after');
                    template = template.replace(':arg0', '<input type="text" placeholder="YYYY-MM-DD" ng-model="rule.args[0]" class="form-control input-xs" />');
                    return template;
                }
            },
            before: {
                label: $translate.instant('validation.rules.before'),
                new: function() {
                    return {
                        name: 'before',
                        args: ['']
                    };
                },
                validateRule: function(rule) {
                    rule.args[0] = rule.args[0].replace(/[^\d-]*/g,'');
                },
                invalidValue: (value, args) => args[0] > value,
                template: () => {
                    var template = $translate.instant('validation.template.before');
                    template = template.replace(':arg0', '<input type="text" placeholder="YYYY-MM-DD" ng-model="rule.args[0]" class="form-control input-xs" />');
                    return template;
                }
            },
            required: {
                label: $translate.instant('validation.rules.required'),
                new: function() {
                    return {
                        name: 'required',
                        args: []
                    };
                },
                validateRule: angular.noop,
                invalidValue: value => (!value || !value.length),
                template: () => $translate.instant('validation.template.required')
            },
            required_if: {
                label: $translate.instant('validation.rules.required_if'),
                new: function() {
                    return {
                        name: 'required_if',
                        args: ['', 'value']
                    };
                },
                validateRule: function(rule, rules) {
                    rule.args[0] = rule.args[0].replace(/[^A-Za-z0-9-]/g,'');
                    rule.args[1] = rule.args[1].replace(/[,|]/g,'');
                },
                invalidValue: (value, args, values) => {
                    if(
                        (!value || !value.length) &&
                        (
                            (values[args[0]] === args[1]) ||
                            (values[args[0]] instanceof Array && values[args[0]].includes(args[1]))
                        )
                    ) {
                        return {
                            other: MetaData.cached[args[0]].name,
                            value: args[1]
                        };
                    }
                    return false;
                },
                template: () => {
                    var template = $translate.instant('validation.template.required_if');
                    template = template.replace(':arg0','<select ng-options="field.guid as field.translatedName for field in otherFields" ng-model="rule.args[0]" class="form-control input-xs"></select>');
                    template = template.replace(':arg1','<input type="text" ng-model="rule.args[1]" class="form-control input-xs"/>');
                    return template;
                }
            },
            required_unless: {
                label: $translate.instant('validation.rules.required_unless'),
                new: function() {
                    return {
                        name: 'required_unless',
                        args: ['', 'value']
                    };
                },
                validateRule: function(rule, rules) {
                    rule.args[0] = rule.args[0].replace(/[^A-Za-z0-9-]/g,'');
                    rule.args[1] = rule.args[1].replace(/[,|]/g,'');
                },
                invalidValue: (value, args, values) => {
                    if(
                        (!value || !value.length) &&
                        (
                            (values[args[0]] !== args[1]) ||
                            (values[args[0]] instanceof Array && !values[args[0]].includes(args[1]))
                        )
                    ) {
                        return {
                            other: MetaData.cached[args[0]].name,
                            value: args[1]
                        };
                    }
                    return false;
                },
                template: () => {
                    var template = $translate.instant('validation.template.required_unless');
                    template = template.replace(':arg0','<select ng-options="field.guid as field.translatedName for field in otherFields" ng-model="rule.args[0]" class="form-control input-xs"></select>');
                    template = template.replace(':arg1','<input type="text" ng-model="rule.args[1]" class="form-control input-xs"/>');
                    return template;
                }
            },
            required_with: {
                label: $translate.instant('validation.rules.required_with'),
                new: function() {
                    return {
                        name: 'required_with',
                        args: ['']
                    };
                },
                validateRule: angular.noop,
                invalidValue: (value, args, values) => {
                    if((!value || !value.length) && values[args[0]] && values[args[0]].length) {
                        return {
                            values: MetaData.cached[args[0]].name
                        };
                    }
                    return false;
                },
                template: () => {
                    var template = $translate.instant('validation.template.required_with');
                    template = template.replace(':arg0','<select ng-options="field.guid as field.translatedName for field in otherFields" ng-model="rule.args[0]" class="form-control input-xs"></select>');
                    return template;
                }
            },
            required_without: {
                label: $translate.instant('validation.rules.required_without'),
                new: function() {
                    return {
                        name: 'required_without',
                        args: ['']
                    };
                },
                validateRule: angular.noop,
                invalidValue: (value, args, values) => {
                    if((!value || !value.length) && (!values[args[0]] || !values[args[0]].length)) {
                        return {
                            values: MetaData.cached[args[0]].name
                        };
                    }
                    return false;
                },
                template: () => {
                    var template = $translate.instant('validation.template.required_without');
                    template = template.replace(':arg0','<select ng-options="field.guid as field.translatedName for field in otherFields" ng-model="rule.args[0]" class="form-control input-xs"></select>');
                    return template;
                }
            },
            numeric: {
                label: $translate.instant('validation.rules.numeric'),
                new: function() {
                    return {
                        name: 'numeric',
                        args: []
                    };
                },
                validateRule: angular.noop,
                invalidValue: value => !/^[\d\.,]*$/.test(value + ''),
                template: () => $translate.instant('validation.template.numeric')
            },
            accepted: {
                label: $translate.instant('validation.rules.accepted'),
                new: function() {
                    return {
                        name: 'accepted',
                        args: []
                    };
                },
                validateRule: angular.noop,
                invalidValue: (value) => !value,
                template: () => $translate.instant('validation.template.accepted')
            },
            array: {
                label: $translate.instant('validation.rules.array'),
                new: function() {
                    return {
                        name: 'array',
                        args: []
                    };
                },
                validateRule: angular.noop,
                invalidValue: () => false,
                template: () => $translate.instant('validation.template.array')
            },
            in: {
                label: $translate.instant('validation.rules.in'),
                new: function() {
                    return {
                        name: 'in',
                        args: ['A,B,C']
                    };
                },
                validateRule: function(rule, rules) {
                    rule.args[0] = rule.args[0].replace(/\s?,\s?/g,',');
                },
                invalidValue: (value, args, values, meta) => {
                    if(!value || !value.length) return false; // Don't enforce required
                    if(meta.type === 'enumOther') return false; // Can't check validity of the enumOther, anything is possible
                    var options = args[0].split(',');
                    if(_.isString(value))
                        return !_.includes(options, value);
                    return _.some(value, function(v){
                        return !_.includes(options, v);
                    });
                },
                template: () => $translate.instant('validation.template.in').replace(':arg0','<input type="text" ng-model="rule.args[0]" class="form-control input-xs"/>')
            },
            digits_between: {
                label: $translate.instant('validation.rules.digits_between'),
                new: function() {
                    return {
                        name: 'digits_between',
                        args: [1,5]
                    };
                },
                validateRule: function(rule, rules) {
                    rule.args[0] = parseInt((rule.args[0] + '').replace(/\D/g,''),10);
                    if(isNaN(rule.args[0])) rule.args[0] = 0;
                    rule.args[1] = parseInt((rule.args[1] + '').replace(/\D/g,''),10);
                    if(isNaN(rule.args[1])) rule.args[1] = 5;
                },
                invalidValue: (value, args) => {
                    if(/[0-9,.]*/.test(value)) {
                        var digits = ('' + value).length;
                        if(digits <= args[1] && digits >= args[0])
                            return false;
                    }
                    return {
                        min: args[0],
                        max: args[1]
                    };
                },
                template: () => {
                    var template = $translate.instant('validation.template.digits_between');
                    template = template.replace(':arg0', '<input type="number" ng-model="rule.args[0]" class="form-control input-xs"/>');
                    template = template.replace(':arg1', '<input type="number" ng-model="rule.args[1]" class="form-control input-xs"/>');
                    return template;
                }
            },
            date: {
                label: $translate.instant('validation.rules.date'),
                new: function() {
                    return {
                        name: 'date',
                        args: []
                    };
                },
                validateRule: angular.noop,
                invalidValue: (value) => {
                    if(!value || !value.length) return false;
                    return !/\d{4}-\d{2}-\d{2}/.test(value);
                },
                template: () => $translate.instant('validation.template.date')
            },
            email: {
                label: $translate.instant('validation.rules.email'),
                new: function() {
                    return {
                        name: 'email',
                        args: []
                    };
                },
                validateRule: angular.noop,
                invalidValue: (value) => {
                    if(!value || !value.length) return false;
                    // Non unicode variant from https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
                    var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
                    return !emailRegex.test(value);
                },
                template: () => $translate.instant('validation.template.email')
            },
            image: {
                label: $translate.instant('validation.rules.image'),
                new: function() {
                    return {
                        name: 'image',
                        args: []
                    };
                },
                // @TODO implement for file
                invalidValue: () => false,
                validateRule: angular.noop,
                template: () => $translate.instant('validation.template.image')
            },
            mimes: {
                label: $translate.instant('validation.rules.mimes'),
                new: function() {
                    return {
                        name: 'mimes',
                        args: ['jpeg,png']
                    };
                },
                validateRule: function(rule, rules) {
                    rule.args[0] = rule.args[0].replace(/\s?,\s?/g,',');
                },
                // @TODO implement for file
                invalidValue: () => false,
                template: () => $translate.instant('validation.template.mimes').replace(':arg0','<input type="text" ng-model="rule.args[0]" class="form-control input-xs"/>')
            },
            size: {
                label: $translate.instant('validation.rules.size'),
                new: function() {
                    return {
                        name: 'size',
                        args: [1024]
                    };
                },
                validateRule: function(rule, rules) {
                    rule.args[0] = parseInt((rule.args[0] + '').replace(/\D/g,''),10);
                    if(isNaN(rule.args[0])) rule.args[0] = 0;
                },
                invalidValue: (value, args, values, meta) => {
                    if(meta.type === 'integer' && parseInt(value,10) !== args[0]) {
                        return {
                            error: 'validation.size.numeric',
                            size: args[0]
                        };
                    }
                    if(meta.type === 'string' && value && value.length !== args[0]) {
                        return {
                            error: 'validation.size.string',
                            size: args[0]
                        };
                    }
                    // @TODO implement for file
                    // if(meta.type === 'file')
                    return false;
                },
                template: () => $translate.instant('validation.template.size').replace(':arg0','<input type="text" ng-model="rule.args[0]" class="form-control input-xs"/>')
            },
            min: {
                label: $translate.instant('validation.rules.min'),
                new: function() {
                    return {
                        name: 'min',
                        args: [0]
                    };
                },
                validateRule: function(rule, rules) {
                    rule.args[0] = parseInt((rule.args[0] + '').replace(/\D/g,''),10);
                    if(isNaN(rule.args[0])) rule.args[0] = 0;
                },
                invalidValue: (value, args, values, meta) => {
                    if(!value || !value.length) return false;
                    if(meta.type === 'integer' && parseInt(value,10) < args[0]) {
                        return {
                            error: 'validation.min.numeric',
                            min: args[0]
                        };
                    }
                    if(meta.type === 'string' && value && value.length < args[0]) {
                        return {
                            error: 'validation.min.string',
                            min: args[0]
                        };
                    }
                    // @TODO implement for file
                    return false;
                },
                template: () => $translate.instant('validation.template.min').replace(':arg0','<input type="text" ng-model="rule.args[0]" class="form-control input-xs"/>')
            },
            max: {
                label: $translate.instant('validation.rules.max'),
                new: function() {
                    return {
                        name: 'max',
                        args: [10]
                    };
                },
                validateRule: function(rule, rules) {
                    rule.args[0] = parseInt((rule.args[0] + '').replace(/\D/g,''),10);
                    if(isNaN(rule.args[0])) rule.args[0] = 10;
                },
                invalidValue: (value, args, values, meta) => {
                    if(!value || !value.length) return false;
                    if(meta.type === 'integer' && parseInt(value,10) > args[0]) {
                        return {
                            error: 'validation.max.numeric',
                            max: args[0]
                        };
                    }
                    if(meta.type === 'string' && value && value.length > args[0]) {
                        return {
                            error: 'validation.max.string',
                            max: args[0]
                        };
                    }
                    return false;
                // @TODO implement for file
                },
                template: () => $translate.instant('validation.template.max').replace(':arg0','<input type="text" ng-model="rule.args[0]" class="form-control input-xs"/>')
            },
            regex: {
                label: $translate.instant('validation.rules.regex'),
                new: function() {
                    return {
                        name: 'regex',
                        args: ['/.*/']
                    };
                },
                invalidValue: (value, args) => {
                    let components = args[0].split('/');
                    if(components.length < 3)
                        throw new Error();
                    let flags = components.pop(),
                        match = components.slice(1).join('/'),
                        r = new RegExp(match, flags);
                    return !r.test(value);
                },
                validateRule: function(rule, rules, el) {
                    if(rules.length > 1) {
                        var ri = _.findIndex(rules,rule);
                        rules.splice(0,ri);
                        rules.splice(ri + 1,99);
                    }
                    try {
                        let components = rule.args[0].split('/');
                        if(components.length < 3)
                            throw new Error();
                        let flags = components.pop(),
                            match = components.slice(1).join('/'),
                            r = new RegExp(match, flags);
                        if(el)
                            el.find('.text-danger').addClass('hidden');
                    } catch(e) {
                        $log.error('Not a valid regular expression');
                        if(el)
                            el.find('.text-danger').removeClass('hidden');

                    }
                },
                template: () => $translate.instant('validation.template.regex').replace(':arg0','<input type="text" ng-model="rule.args[0]" class="form-control monospace input-xs"/> <span class="hidden text-danger" style="font-variant: small-caps; font-weight: bold">invalid</span>')
            }
        };

        /*
     * Utility functions for Validation rule sets
     */
        Object.defineProperties(Rules, {
        /**
         * @ngdoc method
         * @name eventix.common.services.LaravelValidationRules#parse
         * @methodOf eventix.common.services.LaravelValidationRules
         * @description
         * Parse a stringified rule configuration
         *
         * @param {String} ruleSet A rule config like `required|in:a,b,c`
         * @returns {Rule[]} An array of rule configs `{name: 'in', args: []}`
         */
            parse: {
                value: function parse(ruleSet) {
                    var rules;
                    if(!ruleSet || typeof ruleSet !== 'string')
                        return [];

                    if(ruleSet.indexOf('regex') > -1)
                        rules = [ruleSet];
                    else
                        rules = ruleSet.split('|');

                    rules = _.map(rules, rule => {
                        let args = [];
                        if(!rule || !rule.length)
                            return null;
                        rule = rule.split(':');
                        if(rule[0] === 'regex' || rule[0] === 'in')
                            args = [rule.slice(1).join(':')];
                        else if(rule.length > 1)
                            args = rule.slice(1).join(':').split(',');
                        return {
                            name: rule[0],
                            args: args
                        };
                    });
                    return rules;
                },
                enumerable: false
            },
            /**
         * @ngdoc method
         * @name eventix.common.services.LaravelValidationRules#stringify
         * @methodOf eventix.common.services.LaravelValidationRules
         * @description
         * Stringify an array of rule configs
         *
         * @param {Rule[]} rules An array of rule configs `{name: 'in', args: []}`
         * @returns {String} A rule config like `required|in:a,b,c`
         */
            stringify: {
                value: function(rules) {
                    return _.chain(rules)
                        .map( rule => `${ rule.name }${ rule.args.length ? ':' + rule.args.join(',') : '' }`)
                        .join('|').value();
                },
                enumerable: false
            },
            /**
         * @ngdoc method
         * @name eventix.common.services.LaravelValidationRules#validate
         * @methodOf eventix.common.services.LaravelValidationRules
         * @description
         * Validate a metadata field
         *
         * @param {Array<MetaData>} metadata Instances of MetaData
         * @param {Object} values A map of filled in values
         * @returns {Object} An object of errors `{metaGuid: String[]}`
         */
            validate: {
                enumerable: false,
                writable: true,
                value: function(metadata, values) {

                    var errors = _.chain(metadata).map(meta => {

                        var rules = Rules.parse(meta.extra);
                        var value = values[meta.guid];

                        if(meta.forced && !_.find(rules, {name: 'required'}))
                            rules.unshift(this.required.new());

                        var errors = _.map(rules, rule => {

                            // Skip validation rules that are not present: nullable, url
                            if (!Rules[rule.name]) {
                                return false;
                            }

                            let invalid = Rules[rule.name].invalidValue(value, rule.args, values, meta);

                            if(!!invalid) {
                                if(!_.isObject(invalid))
                                    invalid = {};
                                invalid.error = invalid.error || 'validation.' + rule.name;
                                invalid.attribute = $translate.instant(meta.translateName);
                                return $translate.instant(invalid.error, invalid);
                            }

                            return false;

                        });

                        errors = _.compact(errors);

                        return [meta.guid,errors];

                    }).fromPairs().value();

                    return errors;

                }
            },
            /**
         * @ngdoc method
         * @name eventix.common.services.LaravelValidationRules#validateRule
         * @methodOf eventix.common.services.LaravelValidationRules
         * @description
         * Proxy for `LaravelValidationRules[rule.name].validateRule`
         *
         * @param {Object} rule A rule config generated with `LaravelValidationRules[name].new()`
         * @param {Object[]} rules An array of rules
         * @returns {Boolean} Valid or not?
         */
            validateRule: {
                enumarable: false,
                value: function(rule, rules) {
                    return Rules[rule.name].validateRule(rule, rules);
                }
            }
        });

        return Rules;
    }).name;
